var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{ref:"psvdbg",staticStyle:{"width":"100vw","height":"100vh"},attrs:{"id":"viewer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }